import styled from 'styled-components';
import { Container } from 'styles';

export const StyledMovingDetail = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;

export const PreviousAddressBackDrop = styled(Container)`
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
`;
